<template>
  <span :class="'McIcon' + (sized ? ' sized' : '')" v-bind="$attrs" v-on="listeners">
    <font-awesome-layers v-if="icon === 'signal-sleep'" fixed-width>
      <font-awesome-icon :icon="['fad', 'signal-alt']" style="opacity: .5" />
      <font-awesome-icon :icon="['fad', 'snooze']" transform="shrink-6 up-7 left-4" />
    </font-awesome-layers>

    <font-awesome-layers v-else-if="icon === 'signal-unknown'" fixed-width>
      <font-awesome-icon :icon="['fad', 'signal-alt']" style="opacity: .5" />
      <font-awesome-icon icon="question" transform="shrink-6 up-7 left-7" />
    </font-awesome-layers>

    <font-awesome-layers v-else-if="icon === 'battery-unknown'" fixed-width>
      <font-awesome-icon :icon="['fad', 'battery-empty']" transform="down-6" />
      <font-awesome-icon icon="question" transform="shrink-6 up-7" />
    </font-awesome-layers>

    <font-awesome-icon v-else :icon="icon" fixed-width />
  </span>
</template>

<script>
export default {
  props: {
    icon: [String, Array],
    sized: Boolean,
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
      }
    },
  },
}
</script>

<style scoped>
.McIcon.sized {
  padding: 0.25rem 0.4rem;
  width: 2.2rem;
  text-align: center;
  margin: 0 0.25rem 0 0;
  border-radius: 0.2rem;
}
</style>
